module.exports = __webpack_public_path__ + "img/nda.73092cfd.svg";